import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ConfirmBody = ({ title, messages, onCancel, onConfirm }) => [
    <Modal.Header key="confirm-modal-header">
        <Modal.Title>{title}</Modal.Title>
    </Modal.Header>,
    <Modal.Body key="confirm-modal-body">
        <div className="container-fluid">
            {
                messages.map(message => <div className="message-line" key={message}>{message}</div>)
            }
        </div>
    </Modal.Body>,
    <Modal.Footer key="confirm-modal-footer">
        <Button onClick={onCancel} className="btn-outline">Cancel</Button>
        <Button onClick={onConfirm} bsStyle="primary">Confirm</Button>
    </Modal.Footer>,
];

export default ConfirmBody;
